import { render } from "./eventregister.vue?vue&type=template&id=e8171c48"
import script from "./eventregister.vue?vue&type=script&lang=js"
export * from "./eventregister.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__